<template>
  <div class="container">
    <div class="logo-container">
      <img src="../assets/sample-logo.png" alt="" />
    </div>
    <div v-if="success" class="success-msg active">
      <img src="../assets/check-circle.png" alt="" />
      <p class="fs2">{{Order_retrieved_label}}</p>
    </div>
    <div id="error-msg-1" class="error-msg">
      <img src="../assets/exclamation-triangle.png" alt=""/>
      <p v-html="errorMessage"></p>
    </div>
    <div aria-hidden="true" class="separator"></div>
    <h1 v-if="success"> {{details_label}}</h1>
    <div v-if="details && details.details !== null" >
      <div class="details-table"  v-for="(detail,index) in otherDetails" :key="detail">
        <div class="x title-txt">
          <p class="gc-title"> {{details_group_label}} {{index+1}} - {{rewardData.reward.name}}</p>
          <img class="brand-img-thumbnail" :src="rewardData.reward.image" :alt="`Gift card: ${rewardData.reward.name}`" />
        </div>
          <div v-if=" typeof detail ==='object'">
            <div class = "x" v-for="(value,key) in detail" :key="value">
              <p class="key">{{key}}</p>
                <div v-if="isUrl(value) === false" class="order-code-val">
                  <span>{{value}}</span>
                </div>
                <div v-else class="order-code-val">
                  <a aria-label="Visit the virtual reward center (opens a new window)" target="_blank" v-bind:href="value">{{value}}</a>
                </div>
            </div>
          </div>
          <div class = "x"  v-else>
            <span>{{detail}}</span>
          </div>
      </div>
    </div>
    <span class="sr-only" aria-live="polite" role="status">{{showLabel && (errorMessage || success) ? getStatusLabel : ''}}</span>
  </div>
</template>

<script>
  import axios from 'axios';
  import { store } from '../../js/reactiveStates.js';

  export default {
    name: "page-3",
    props:['rewardData','rewardDetails'],
    computed: {
      getStatusLabel() {
        if (this.success) {
          return this.Order_retrieved_label
        } else {
          return this.errorMessage
        }
      }
    },
    data: function (){
      return {
        showLabel: false,
        details: this.rewardDetails.details,
        rewardDataLocal: this.rewardData,
        root:process.env.VUE_APP_SERVICE_URL,
        apiToken:'',
        errorMessage: '',
        success: true,
        detailsObjects:[],
        otherDetails:[],
        counter:0,
        details_label: 'Order Details',
        Order_retrieved_label: 'Order details retrieved.',
        details_group_label: 'Card',
        store
      };
    },
  mounted(){
    this.$nextTick(() => {
      if (this.success) {
        setTimeout(() => {
          this.showLabel = true
        }, 800)
      }
    })
    if(!this.rewardDetails.details){
        this.updatePage();
      } else {

        if( this.rewardDetails.page_info.details_label &&  this.rewardDetails.page_info.details_label.length>0){
          this.details_label = this.rewardDetails.page_info.details_label;
        }
        if(this.rewardDetails.message && this.rewardDetails.message.length>0){
          this.Order_retrieved_label = this.rewardDetails.message;
        }

        if(this.rewardDetails.page_info.details_group_label && this.rewardDetails.page_info.details_group_label.length > 0){
          this.details_group_label = this.rewardDetails.page_info.details_group_label;
        }

        if( this.details.details !== null){
          this.addDetails();
        }
      }


    },
    watch: {
      showLabel(val) {
        if (val) {
          setTimeout(() => {
            this.showLabel = false
          }, 2500)
        }
      },
      store: {
        handler(){
          this.updatePage();
        },
        deep: true
      }
    },
    methods:{
      updatePage() {
        this.otherDetails = [];
        this.apiToken = this.rewardDataLocal.redemption_link.api_token;
        let body = {
          "challenge_code": store.challengeCode
        };
        let url = `${this.root}/grs/v1/redemption_link/${this.apiToken}/process?lang=`+store.chosenLanguage;
        axios.post(url, body)
          .then((resp) =>{
            if(resp.data.success === true ) {
              this.details = resp.data.details;
              if(resp.data.page_info.details_label && resp.data.page_info.details_label.length>0){
                this.details_label =resp.data.page_info.details_label ;
              }

              if(resp.data.message && resp.data.message.length > 0){
                this.Order_retrieved_label = resp.data.message;
              }
              if(resp.data.page_info.details_group_label && resp.data.page_info.details_group_label.length > 0){
                this.details_group_label = resp.data.page_info.details_group_label;
              }

              if( this.details.details !== null){
                this.addDetails();
              }
            } else {
              this.success = false;
              this.showLabel = true
              this.errorMessage = resp.data.message ;
            }
          })
          .then(()=>{
            if(this.success === false ){
              let errorMsgEl = document.getElementById('error-msg-1');
              errorMsgEl.classList.add('active');
            }

          })
          .catch(err => {
            console.log(err)
          })
      },
      addDetails(){
        this.details.details.forEach(ele =>{
          if(Array.isArray(ele)){
            for(let i = 0; i< ele.length;i++){
              this.otherDetails.push(ele[i])
            }
          } else {
            this.otherDetails.push(ele);
          }
        });
      },
      isUrl(str){
         let regexp =  /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
          if (regexp.test(str))
          {
            return true;
          }
          else
          {
            return false;
          }
      }
    }
  }
</script>
